import React, { useState, useEffect } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Row, Col } from 'reactstrap';
import { useTranslation } from "react-i18next";
import moneyTransferImage from '../Assets/Images/finance/money-transfer-vector.jpg';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { useParams, useNavigate } from "react-router-dom";
import moment from 'moment';
import StandartPage from '../Layouts/Shared/_StandartPage';
import CompMoneyTransferBase from '../Components/MoneyTransfer/CompMoneyTransferBase';
import CompMoneyTransferChannels from '../Components/MoneyTransfer/CompMoneyTransferChannels';

import CompLoaderDt from '../Components/Common/CompLoaderDt';

export default function MoneyTransfer() {

    const navigate = useNavigate();
    const params = useParams();

    let moneyTransferId = params.moneyTransferId;
    let tabId = params.tabId;
    const [tabIndex, setTabIndex] = useState(0);

    const [data, setData] = useState(null);


    const { t } = useTranslation();
    const [displayName, setDisplayName] = useState(false);
    const [dataLocked, setDataLocked] = useState(true);
    const [seed, setSeed] = useState(0);
    const [logged, setLogged] = useState(false);
    const [dataMoneyTransferDetails, setDataMoneyTransferDetails] = useState(null);
    const [apiCalled, setApiCalled] = useState(false);
    const [apiCalledBy, setApiCalledBy] = useState(false);

    const [title, setTitle] = useState('');

    useEffect(() => {

        switch (tabId) {
            case "baseInformation": setTabIndex(0); break;
            case "channels": setTabIndex(1); break;
            default:
                navigate('/finance/money-transfer/' + moneyTransferId + '/baseInformation');
                break;
        }

    }, [tabId, moneyTransferId, navigate]);


    useEffect(() => {
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            if (moneyTransferId && moneyTransferId) {
                let currentSession = sessionStorage.getItem("currentSession");
                axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
                axios.defaults.headers.common["Authorization"] = currentSession !== null ? JSON.parse(currentSession)?.bearerToken : null;
                let ApiGateway = process.env.REACT_APP_API_URL;
                axios.get(ApiGateway + '/finance/back-office/money-transfer/' + moneyTransferId + '/find-and-get')
                    .then(response => {
                        setDataMoneyTransferDetails(response?.data?.payload);
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        }
    }, [t, moneyTransferId]);

    return (
        <StandartPage title={t('pages.money-transfer.title')} >
            <React.Fragment>
                <ToastContainer />
                <Row>
                    <Col className="col-12 p-2 container">
                        <React.Fragment>
                            <ToastContainer />
                            {dataMoneyTransferDetails ? ((
                                <Row>
                                    <Col className={"col-md-2"}>
                                        <img src={moneyTransferImage} width={200} height={200} title="Money Transfer" alt="Money Transfer" />
                                        <h4>{t('pages.money-transfer.left-side.money-transfer')}</h4>
                                        <h5>{title}</h5>
                                    </Col>
                                    <Col className={"col-md-10"}>
                                        <Tabs defaultIndex={tabIndex} onSelect={(index) => console.log('changed tab to => ' + index)}>
                                            <TabList>
                                                <Tab>{t('pages.money-transfer.tabs.base-information')}</Tab>
                                                <Tab>{t('pages.money-transfer.tabs.channels')}</Tab>
                                            </TabList>
                                            <TabPanel>
                                                <CompMoneyTransferBase referenceId={dataMoneyTransferDetails?.referenceId} />
                                            </TabPanel>
                                            <TabPanel>
                                                <CompMoneyTransferChannels moneyTransferId={dataMoneyTransferDetails?.id} />
                                            </TabPanel>
                                        </Tabs>
                                    </Col>
                                </Row>
                            )) : (
                                <Row>
                                    <Col className={"col-md-12 text-center"}>
                                        <CompLoaderDt />
                                    </Col>
                                </Row>
                            )}

                        </React.Fragment>
                    </Col>
                </Row>
            </React.Fragment>
        </StandartPage>
    )

}